import React, { useCallback, useContext, useState } from 'react';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import StarIcon from '@mui/icons-material/Star';
import { ChatbotWidgetContext } from 'components/ChatbotWidget/utils/ChatbotWidgetContext';
import { View } from 'components/ChatbotWidget/constants/view';
import styles from './Rating.module.scss';
import classNames from 'classnames/bind';
import { Typography, Input } from 'gd-design-library';
import { Button } from 'components/baseComponents/Button';

const cx = classNames.bind(styles);

const CN = 'rating';
const starsRowClassName = `${CN}__stars-row`;
const selectedStarClassName = `${CN}__selected-star`;

const RATING_OPTIONS = [ 1, 2, 3, 4, 5 ];

export const Rating = (): React.ReactElement => {
  const { setView, client } = useContext(ChatbotWidgetContext);
  const [ rating, setRating ] = useState<number | null>(null);
  const [ feedback, setFeedback ] = useState<string>('');
  const [ isRatingSending, setIsRatingSending ] = useState(false);

  const sendChatRate = useCallback(async () => {
    if (rating === null || !client) return;

    setIsRatingSending(true);

    await client.sendChatRate({ rating, feedback });

    setIsRatingSending(false);
    setView(View.RATING_SUBMITTED);
  }, [ rating, client, feedback, setView ]);

  return (
    <div className={ cx(CN) }>
      <div>
        <Typography align='center' variant='h4'>Rate your experience</Typography>
        <div className={ cx(starsRowClassName) }>
          {RATING_OPTIONS.map(value => (
            <Button
              variant='inherit'
              isIcon
              key={ value }
              onClick={ (): void => setRating(value) }
            >
              {rating && rating >= value
                ? <StarIcon fontSize='large' className={ cx(selectedStarClassName) } />
                : <StarOutlineIcon fontSize='large' />}
            </Button>
          ))}
        </div>
      </div>
      <Input
        label='Feedback'
        name='feedback'
        variant='text'
        value={ feedback }
        onChange={ (e): void => setFeedback(e.target.value) }
      />
      <Button
        onClick={ sendChatRate }
        disabled={ rating === null }
        variant='primary'
        loading={ isRatingSending }
      >
        Submit
      </Button>
    </div>
  );
};
